import Button from "@edaz/edazkit/Button";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { Col, Form, Row } from "react-bootstrap";
import { translateGeneral } from "utils/localizations";

import BalanceCreateViewModel from "viewModels/finance/accountingInventory/balance/balanceCreateViewModel";

const BalanceCreateView: ViewComponent<BalanceCreateViewModel> = observer(({ vm }) => {
  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      <h3 className="m-0 pb-7 text-left">{vm.translate(vm.isEditMode ? "editTitle" : "title")}</h3>
      <div className="table-full" style={{ borderBottom: "1px solid #DDE1E6" }} />

      {/* FORM */}
      <Col className="my-2">
        <Row lg={12} xl={12} className="m-0 py-4">
          <div className="col-md-3 col-sm-6">
            <Form.Label>{vm.translate("accountingPeriodTo")}</Form.Label>
            <AdvancedSelect
              items={vm.availableMonths}
              target={vm.item}
              property="accountingPeriodTo"
              placeholder={translateGeneral("selectFromList")}
              mode="key"
            />
          </div>
        </Row>
      </Col>

      {/* BOTTOM ACTIONS */}
      <div className="table-full" style={{ borderBottom: "1px solid #DDE1E6", paddingBottom: "30px" }} />
      <Row lg={12} xl={12} style={{ marginTop: "30px" }}>
        <div className="col-md-8 col-sm-4">
          <Button size="sm" type="reset" style={{ borderRadius: "0.25rem" }} variant="light" onClick={vm.onClose}>
            {translateGeneral("cancel")}
          </Button>
        </div>
        <div className="col-md-4 col-sm-4">
          <div className="d-flex justify-content-end">
            <Button size="sm" type="submit" style={{ borderRadius: "0.25rem" }} variant="primary" onClick={vm.onCreate}>
              {translateGeneral("add")}
            </Button>
          </div>
        </div>
      </Row>
    </LoaderOverlay>
  );
});

registerView(BalanceCreateView, BalanceCreateViewModel);
